import { Component } from 'react';
import { wireAuthConsumer } from 'automation-ui-core/context/AuthContext';
import UIPanelBody from 'UIComponents/panel/UIPanelBody';
import UIOptimisticNanoProgress from 'UIComponents/progress/UIOptimisticNanoProgress';
import ActionConfigCombinedHeaderContainer from 'automation-ui-action-features/components/ActionConfigCombinedHeaderContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class LoadingActionConfig extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pastDelay: false
    };
    this._isUnmounted = false;
    setTimeout(() => {
      if (!this._isUnmounted) {
        this.setState({
          pastDelay: true
        });
      }
    }, props.loadingDelay);
  }
  componentWillUnmount() {
    this._isUnmounted = true;
  }
  render() {
    const {
      pastDelay
    } = this.state;
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(ActionConfigCombinedHeaderContainer, {
        children: "\xA0"
      }), /*#__PURE__*/_jsx(UIPanelBody, {
        "data-test-id": "loading-action-config",
        children: pastDelay ? /*#__PURE__*/_jsx(UIOptimisticNanoProgress, {}) : null
      })]
    });
  }
}
LoadingActionConfig.defaultProps = {
  loadingDelay: 200
};
export default wireAuthConsumer(LoadingActionConfig);